import { createApp } from 'vue'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueCookies from 'vue-cookies'
import http from "./assets/js/http.js"
import ViewUIPlus from 'view-ui-plus'
import 'view-ui-plus/dist/styles/viewuiplus.css'
import VueAMap from 'vue3-amap'
import Swiper from "swiper";
// import 'swiper/css';
import "swiper/swiper-bundle.min.js";
import "swiper/swiper-bundle.min.css";
import SwiperCore, {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Autoplay
} from "swiper";
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay])
const app = createApp(App)
app.use(ViewUIPlus)
app.use(VueAMap)
function getUrlParam(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
  var r = window.location.search.substr(1).match(reg); //匹配目标参数
  // console.log(r);
  if (r != null) return unescape(r[2]);
  return null; //返回参数值
}
// app.use(Swiper)
// 相当于Vue.prototype.$cookies
app.config.globalProperties.$http = http
app.config.globalProperties.$getUrlParam = getUrlParam
app.config.globalProperties.$cookies = VueCookies
app.config.globalProperties.$VueAMap = VueAMap
app.config.globalProperties.$Swiper = Swiper
//  app.provide('$cookies', VueCookies)

app.use(router).mount('#app')
